import { createAction } from 'redux-actions';
import { SET_SELECTED_ACCOUNT, SET_ALL_ACCOUNT } from 'redux/constants';


const setAllAccountDetails: any = createAction(SET_ALL_ACCOUNT, (value: any) => {
	return value;
});

const setSelectedAccountDetails: any = createAction(SET_SELECTED_ACCOUNT, (value: any) => {
	return value;
});

export { setSelectedAccountDetails, setAllAccountDetails };
